
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/l/scheinfirmen",
      function () {
        return require("private-next-pages/l/scheinfirmen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/l/scheinfirmen"])
      });
    }
  